import React, { Component } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  CircularProgress,
  Box,
  TextField,
  InputAdornment,
  IconButton,
  Chip,
  Divider,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import DeleteIcon from "@mui/icons-material/Delete";
import { apiUrl } from "../../../comps/apiUrl";

class EquipamentoDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      query: "",
      equipamentos: [], // Itens vindos da busca atual
      selectedItems: [], // Objetos completos selecionados
      loading: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.open && !prevProps.open) {
      this.fetchEquipamentos();

      // Se existirem produtos já salvos na página, carrega-os para o estado interno
      if (this.props.selectedProducts) {
        this.setState({ selectedItems: [...this.props.selectedProducts] });
      } else {
        this.setState({ selectedItems: [] });
      }
    }
  }

  fetchEquipamentos = async () => {
    const { query } = this.state;

    this.setState({ loading: true });
    try {
      const response = await fetch(
        `${apiUrl}/v2/equipment/search${
          query ? `?query=${query}` : "/preferences"
        }`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: localStorage.getItem("token"),
          },
        }
      );
      const data = await response.json();
      this.setState({ equipamentos: data || [], loading: false });
    } catch (err) {
      console.error("Erro na busca:", err);
      this.setState({ loading: false });
    }
  };

  // Seleciona ou remove o item da lista de objetos selecionados
  handleToggle = (item) => {
    const { selectedItems } = this.state;
    if (!item.estoque_total || item.estoque_total <= 0) {
      return;
    }
    const isSelected = selectedItems.some((i) => i.id === item.id);

    let newSelection;
    if (isSelected) {
      newSelection = selectedItems.filter((i) => i.id !== item.id);
    } else {
      newSelection = [...selectedItems, item];
    }

    this.setState({ selectedItems: newSelection });
  };

  // Função específica para deletar da barra inferior
  handleDeleteChip = (id) => {
    const { selectedItems } = this.state;
    this.setState({
      selectedItems: selectedItems.filter((i) => i.id !== id),
    });
  };

  handleConfirm = () => {
    // Envia a lista atualizada (se removeu no chip, aqui já não estará o item)
    this.props.onSave(this.state.selectedItems);
    this.props.onClose();
  };

  render() {
    const { open, onClose } = this.props;
    const { query, equipamentos, selectedItems, loading } = this.state;

    return (
      <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          Pesquisar Equipamentos
          <Box sx={{ width: "300px" }}>
            <TextField
              fullWidth
              size="small"
              placeholder="Buscar..."
              value={query}
              onChange={(e) => this.setState({ query: e.target.value })}
              onKeyPress={(e) => e.key === "Enter" && this.fetchEquipamentos()}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={this.fetchEquipamentos} edge="end">
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        </DialogTitle>

        <DialogContent dividers sx={{ height: "400px" }}>
          {loading ? (
            <Box sx={{ display: "flex", justifyContent: "center", mt: 10 }}>
              <CircularProgress />
            </Box>
          ) : (
            <TableContainer>
              <Table stickyHeader size="small">
                <TableHead>
                  <TableRow>
                    <TableCell padding="checkbox" />
                    <TableCell>Descrição</TableCell>
                    <TableCell align="right">Estoque</TableCell>
                    <TableCell align="right">Itens</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {equipamentos.map((item) => {
                    const isChecked = selectedItems.some(
                      (i) => i.id === item.id
                    );
                    const semEstoque =
                      !item.estoque_total || item.estoque_total <= 0;
                    return (
                      <TableRow
                        key={item.id}
                        hover
                        onClick={() => this.handleToggle(item)}
                        sx={{
                          cursor: semEstoque ? "not-allowed" : "pointer",
                          bgcolor: semEstoque ? "#fafafa" : "inherit",
                          opacity: semEstoque ? 0.6 : 1,
                        }}
                        selected={isChecked}
                      >
                        <TableCell padding="checkbox">
                          <Checkbox checked={isChecked} />
                        </TableCell>
                        <TableCell>{item.name}</TableCell>
                        <TableCell align="right">
                          {item.estoque_total || 0}
                        </TableCell>
                        <TableCell align="right">
                          <Chip
                            label={item.itens == 1 ? "Sim" : "Não"}
                            size="small"
                            color={item.itens == 1 ? "success" : "default"}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </DialogContent>

        {/* ÁREA DE ITENS SELECIONADOS (RODAPÉ) */}
        <Box sx={{ p: 2, bgcolor: "#f9f9f9" }}>
          <Typography variant="subtitle2" gutterBottom color="textSecondary">
            Itens Selecionados ({selectedItems.length}):
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 1,
              minHeight: "32px",
            }}
          >
            {selectedItems.length === 0 && (
              <Typography variant="caption" color="textDisabled">
                Nenhum item selecionado.
              </Typography>
            )}
            {selectedItems.map((item) => (
              <Chip
                key={item.id}
                label={item.name}
                onDelete={() => this.handleDeleteChip(item.id)}
                color="primary"
                variant="outlined"
                size="small"
                deleteIcon={<DeleteIcon />}
              />
            ))}
          </Box>
        </Box>

        <Divider />

        <DialogActions sx={{ p: 2 }}>
          <Button onClick={onClose} color="inherit">
            Cancelar
          </Button>
          <Button onClick={this.handleConfirm} variant="contained">
            Salvar {selectedItems.length > 0 ? `(${selectedItems.length})` : ""}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default EquipamentoDialog;
